import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/en-translations.json";
import fr from "./locales/fr/fr-translations.json";
i18n.use(initReactI18next).init({
  fallbackLng: "fr",
  lng: "fr",
  resources: {
    en: {
      translations: en,
    },
    fr: {
      translations: fr,
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["en", "fr"];

export default i18n;
